// extracted by mini-css-extract-plugin
export default {"test_card":"PartSurvey_test_card__Wdc3X"};